/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramBouncesControllerHandleBounceMutationResponse,
  TelegramBouncesControllerHandleBounceHeaderParams,
} from '../../types/TelegramBouncesControllerHandleBounce.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramBouncesHandleBounce } from '../../methods/telegramBouncesHandleBounce.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramBouncesHandleBounceMutationKey = () => [{ url: '/api/telegram/bounces' }] as const;

export type TelegramBouncesHandleBounceMutationKey = ReturnType<typeof telegramBouncesHandleBounceMutationKey>;

/**
 * {@link /api/telegram/bounces}
 */
export function useTelegramBouncesHandleBounce<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramBouncesControllerHandleBounceMutationResponse,
      ResponseErrorConfig<Error>,
      { headers: TelegramBouncesControllerHandleBounceHeaderParams },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramBouncesHandleBounceMutationKey();

  return useMutation<
    TelegramBouncesControllerHandleBounceMutationResponse,
    ResponseErrorConfig<Error>,
    { headers: TelegramBouncesControllerHandleBounceHeaderParams },
    TContext
  >(
    {
      mutationFn: async ({ headers }) => {
        return telegramBouncesHandleBounce(headers, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
